export default __webpack_public_path__ + "static/media/View_Camera.5b3c3d3e.png";